import React from "react";
import { motion } from "framer-motion";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8 px-4">
        {/* Company Description */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex justify-start px-2">
            <img
              src="https://res.cloudinary.com/dhhsupcai/image/upload/v1726647751/thrd6ytbgmj5fdvlphd7.png"
              alt="Comfie Blinds Logo"
              className="h-20"
            />
          </div>
          <p className="mt-4 text-gray-300">
            Best place to buy window blinds online. We offer a variety of blinds to
            suit any need, including Roller, Vertical blinds, Shades, and
            Shutters. Free Shipping.
          </p>
          <div className="flex space-x-4 mt-4">
            <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF className="text-white text-2xl" />
            </motion.a>
            <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="text-white text-2xl" />
            </motion.a>
            <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-white text-2xl" />
            </motion.a>
            <motion.a whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }} href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <FaYoutube className="text-white text-2xl" />
            </motion.a>
          </div>
        </motion.div>

        {/* Shop By Type */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }}>
          <h5 className="text-lg font-semibold text-blue-400 mb-3 border-b-2 border-blue-400 pb-2">Shop By Type</h5>
          <ul className="space-y-2">
            {['Roller Shades', 'Zebra Blinds'].map((item, index) => (
              <motion.li key={index} whileHover={{ scale: 1.05, color: "#ffffff" }}>
                {item}
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* Quick Links */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.7 }}>
          <h5 className="text-lg font-semibold text-blue-400 mb-3 border-b-2 border-blue-400 pb-2">Quick Links</h5>
          <ul className="space-y-2">
            {['About Us', 'Our Products', 'Free Samples', 'Commercial Blinds', 'Blogs', 'Contact Us'].map((item, index) => (
              <motion.li key={index} whileHover={{ scale: 1.05, color: "#ffffff" }}>
                {item}
              </motion.li>
            ))}
          </ul>
        </motion.div>

        {/* Contact Info */}
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
          <h5 className="text-lg font-semibold text-blue-400 mb-3 border-b-2 border-blue-400 pb-2">Contact Us</h5>
          <p className="text-gray-300">+1 (604) 360-1483</p>
          <p className="text-gray-300">sales@valueblinds.ca</p>
          <p className="text-gray-300">Call us between 9 AM - 5 PM PST</p>
          <h5 className="text-lg font-semibold text-blue-400 mt-4 mb-3 border-b-2 border-blue-400 pb-2">Payment Options</h5>
          <motion.img
            src="https://res.cloudinary.com/doxeywdfq/image/upload/v1755296718/payment_tmtcam.png"
            alt="Payment Options"
            className="h-12"
            whileHover={{ scale: 1.1 }}
          />
        </motion.div>
      </div>
      <div className="text-center mt-8 text-gray-400 text-sm">
        © {new Date().getFullYear()} Value Blinds. All rights reserved.
      </div>
      <div className="text-center mt-2 text-gray-400 text-sm">
        Developed by <a href="https://odidor.co/" className="text-blue-400 hover:underline">Odidor</a>
      </div>
    </footer>
  );
};

export default Footer;